import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { overview } from 'src/app/core/translations/overview';
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  isHandsetPortrait: boolean = false;

  currentLanguage: string = '';
  languageTranslations: any = overview;
  activeLanguageTranslations: any = {};
  
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {
        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
}
